/* eslint-disable @typescript-eslint/ban-types */
import { Cell } from 'react-table';

import { dateToTime } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a time like: 06:30:16 PM
 * @param Props must contain a `cell.value` which is either a string or number that can be used to
 * instantiate a JavaScript Date. Usually this will be an AWSDateTime, which is an ISO8601 date
 * string.
 */
export function TimeCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const { value } = cell;

    if (value === null) {
        return 'None';
    }

    const date = new Date(value);

    return dateToTime(date, true);
}
